<template>
  <v-container fluid v-if="show">
    <v-dialog v-model="show" max-width="400px">
      <v-card>
        <v-card-title class="secondary white--text d-flex align-center justify-space-between">
          <span class="header-font" style="font-size: 22px;">{{ $t(title) }}</span>
        </v-card-title>
        <v-card-text class="mt-5">
          <v-container class="pa-0">
            <p class="body-1 primary--text">{{$t("login.forgotPasswordMessage")}}</p>
            <v-form name="form" ref="formRef" @submit.prevent="onSaveClick">
              <v-row>
                <v-col cols="12" class="py-1">
                  <p class="body-1 font-weight-bold primary--text pb-1 mb-0">Email</p>
                  <v-text-field outlined dense hide-details
                    v-model="user.email"
                    placeholder=" "
                    :rules="emailRules"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="pr-6 pb-4 d-flex justify-end">
          <v-btn
            :color="$vuetify.theme.dark ? 'white' : 'secondary'"
            rounded outlined class="elevation-0 monospace-font px-4"
            @click="onCancelClick()"
          >{{$t('general.cancel')}}</v-btn>
          <v-btn
            rounded class="elevation-0 monospace-font white--text px-4" color="primary"
            @click="onSaveClick()"
          >OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import Dictionary from "../../dictionary";
import * as _ from "lodash";

export default {
  name: "ForgotPasswordModal",
  components: {},
  filters: {
  },
  props: {
    title: {
      type: String,
      default: "login.forgotMyPassword"
    }
  },
  data() {
    return {
      user: null,
      show: false,
      emailRules: [
        v =>
          !!v ||
          Dictionary[this.$i18n.locale]["general"]["formErrors"]["required"],
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          Dictionary[this.$i18n.locale]["general"]["formErrors"]["emailValid"]
      ]
    };
  },
  created() {},
  methods: {
    open(user = {}) {
      this.user = user;
      this.show = true;
    },
    close() {
      this.user = null;
      this.show = false;
    },
    onCancelClick() {
      this.$emit("save", null), this.close();
    },
    async onSaveClick() {
      if (this.$refs.formRef.validate()) {
        this.$emit("save", this.user);
        this.close();
      }
    },
    onInputChange() {
      this.$refs.formRef.validate();
    }
  }
};
</script>
